import React from "react";

const Home = () => {
  return (
    <div className="profile-top-area">
      <label className="profile-label">Home</label>
    </div>
  );
};

export default Home;
